<template>
	<div class="sip-view-dl" v-if="product.name">
        <div class="sip-view-dl__row">
            <dt>Product</dt>
            <dd>{{product.name}}</dd>
        </div>
        <div class="sip-view-dl__row">
            <dt>Current version</dt>
            <dd>{{product.current_version}}</dd>
        </div>
        <div class="sip-view-dl__row">
            <dt>Latest version</dt>
            <dd>
                {{product.latest_version}}
                <span v-if="product.current_version == product.latest_version" class="admin-status-badge admin-status-badge--success">Up to date</span>
                <router-link v-else-if="!update" to="/update" class="btn btn-sm admin-toolbar-btn admin-toolbar-btn--outline mt-1">Check updates</router-link>
            </dd>
        </div>
        <div class="sip-view-dl__row" v-if="product.latest_version_release">
            <dt>Release date</dt>
            <dd>{{product.latest_version_release | moment}}</dd>
        </div>
    </div>
</template>

<script>
	export default {
		props: {
            product: {
                required: true
            },
            update: {
                required: false,
                default: 0
            }
        },
        filters: {
          moment(date) {
            return helper.formatDate(date);
          }
        }
	}
</script>
